/**
 * https://dev.to/paulriviera/add-azure-application-insights-to-a-static-nextjs-app-921
 */
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import {
  AppInsightsContext,
  ReactPlugin,
  withAITracking,
} from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.NEXT_PUBLIC_APP_INSIGHTS_CONNECTIONSTRING,
    // we cast to any because of some internal typings issue in microsoft:
    // https://github.com/microsoft/applicationinsights-angularplugin-js/issues/97#issuecomment-1435039094
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    extensions: [reactPlugin as any],
    enableAutoRouteTracking: true,
  },
});

appInsights.loadAppInsights();

// eslint-disable-next-line
const telemetryInitializer = (envelope: any) => {
  // eslint-disable-next-line
  envelope.tags['ai.cloud.role'] = 'ConferencesUI';
};

appInsights.addTelemetryInitializer(telemetryInitializer);

const AzureAppInsights = ({ children }: { children: React.ReactNode }) => (
  <AppInsightsContext.Provider value={reactPlugin}>{children}</AppInsightsContext.Provider>
);

const WithAppInsightsTracking = withAITracking(reactPlugin, AzureAppInsights);

export { WithAppInsightsTracking as ApplicationInsights, appInsights };
